module.exports = __webpack_public_path__ + "img/haha.05fc2454.svg";